import React from "react";
import { FiTarget } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import {
  CmdCard,
  CmdCardCta,
  CmdCardHeader,
  CmdCardSub,
  CmdCardTitle,
} from "../styles";

export default function NextActionCard({ nextAction, onScrollCriticos }) {
  const navigate = useNavigate();
  if (!nextAction) return null;

  function handleCta() {
    if (!nextAction.cta) return;
    if (nextAction.cta.kind === "navigate" && nextAction.cta.to) {
      navigate(nextAction.cta.to);
    } else if (nextAction.cta.kind === "scroll-criticos") {
      onScrollCriticos?.();
    }
  }

  return (
    <CmdCard $tone={nextAction.tone}>
      <CmdCardHeader>
        <FiTarget size={13} />
        <span>Próxima ação</span>
      </CmdCardHeader>
      <CmdCardTitle>{nextAction.title}</CmdCardTitle>
      {nextAction.body && <CmdCardSub>{nextAction.body}</CmdCardSub>}
      {nextAction.ctaLabel && nextAction.cta && (
        <CmdCardCta type="button" onClick={handleCta}>
          {nextAction.ctaLabel}
        </CmdCardCta>
      )}
    </CmdCard>
  );
}
